import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { di } from 'react-magnetic-di';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { selectReadyPublicDataForOnInit } from '../../hooks/use-ready-fields/utils';
import { setError } from '../errors';
var getTimeout = function getTimeout() {
  return 50000;
};
var getFieldsInitializationTime = function getFieldsInitializationTime(startTime) {
  return startTime !== null ? performance.now() - startTime : null;
};
var isFieldInitialisationComplete = function isFieldInitialisationComplete(status) {
  return status === 'success' || status === 'timedOut';
};
export var startFieldsInitialisationTimeout = function startFieldsInitialisationTimeout(_ref) {
  var createAnalyticsEvent = _ref.createAnalyticsEvent;
  return function (_ref2) {
    var setState = _ref2.setState,
      getState = _ref2.getState,
      dispatch = _ref2.dispatch;
    var _getState = getState(),
      fieldsInitialization = _getState.fieldsInitialization;
    if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
      var timeoutId = setTimeout(function () {
        return dispatch(failFieldInitilisation({
          createAnalyticsEvent: createAnalyticsEvent
        }));
      }, getTimeout());
      setState({
        fieldsInitialization: {
          startTime: performance.now(),
          timeoutId: timeoutId,
          status: 'inProgress'
        }
      });
    }
  };
};
export var failFieldInitilisation = function failFieldInitilisation(_ref3) {
  var createAnalyticsEvent = _ref3.createAnalyticsEvent;
  return function (_ref4, _ref5) {
    var getState = _ref4.getState,
      setState = _ref4.setState,
      dispatch = _ref4.dispatch;
    var viewType = _ref5.viewType;
    var _getState2 = getState(),
      formData = _getState2.formData,
      experienceDataIsLoading = _getState2.experienceDataIsLoading,
      numberOfSupportedFields = _getState2.numberOfSupportedFields,
      fieldsInitialization = _getState2.fieldsInitialization;
    var startTime = fieldsInitialization.startTime,
      status = fieldsInitialization.status;
    if (isFieldInitialisationComplete(status) || selectReadyPublicDataForOnInit(getState(), {
      viewType: viewType
    }) !== null) {
      return;
    }
    dispatch(setError({
      errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
    }));
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'timedOut',
      actionSubject: 'jiraUiModifications.fieldsInitialization',
      attributes: {
        previousStatus: status,
        configuredTimeout: getTimeout(),
        fieldsInitializationTime: getFieldsInitializationTime(startTime),
        initalizedFieldsCount: Object.keys(formData !== null && formData !== void 0 ? formData : {}).length,
        experienceDataIsLoading: experienceDataIsLoading,
        supportedFieldsCount: numberOfSupportedFields,
        viewType: viewType
      }
    });
    setState({
      fieldsInitialization: _objectSpread(_objectSpread({}, fieldsInitialization), {}, {
        status: 'timedOut'
      })
    });
  };
};
export var successFieldsInitalisation = function successFieldsInitalisation(_ref6) {
  var createAnalyticsEvent = _ref6.createAnalyticsEvent;
  return function (_ref7, _ref8) {
    var getState = _ref7.getState,
      setState = _ref7.setState;
    var viewType = _ref8.viewType;
    var status = getState().fieldsInitialization.status;
    if (isFieldInitialisationComplete(status)) {
      return;
    }
    var _getState3 = getState(),
      numberOfSupportedFields = _getState3.numberOfSupportedFields,
      fieldsInitialization = _getState3.fieldsInitialization;
    var timeoutId = fieldsInitialization.timeoutId,
      startTime = fieldsInitialization.startTime;
    clearTimeout(timeoutId);
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'success',
      actionSubject: 'jiraUiModifications.fieldsInitialization',
      attributes: {
        previousStatus: status,
        fieldsInitializationTime: getFieldsInitializationTime(startTime),
        initalizedFieldsCount: numberOfSupportedFields,
        viewType: viewType
      }
    });
    setState({
      fieldsInitialization: _objectSpread(_objectSpread({}, fieldsInitialization), {}, {
        status: 'success'
      })
    });
  };
};